module.exports = __webpack_public_path__ + "assets/images/50B.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/50B.png
// module id = 1301
// module chunks = 1